import React from 'react';
import { useNavigate } from 'react-router-dom';
import Fade from 'react-reveal/Fade';

import { CollaborateWrapper } from './collaborate.styled';
import Container from '../container/container.component';
import SubmitButton from '../submitButton/submitButton.component';

interface Props {
	className?: string;
	landing?: boolean;
}

const Collaborate = (props: Props) => {
	const { className, landing = true } = props;
	const navigate = useNavigate();
	return (
		<CollaborateWrapper className={className ? className : ''}>
			<Container>
				<Fade top cascade>
					<div className="content">
						<div className="left-section">
							<p className="title">
								{`A catalyst for the future, shaping
								Kuwait's and the region's position as a hub for innovation and
								excellence.`}
							</p>
							{landing && (
								<SubmitButton
									id="view-challenges-btn"
									title={landing ? 'View Challenges' : 'APPLY NOW'}
									icon={true}
									handleClick={() =>
										landing
											? navigate('/challenges/current')
											: navigate('/submit-challenge')
									}
								/>
							)}
						</div>
						<div className="right-section">
							<p className="sub-title">
								{`Join us on this transformative journey as we move into a new era
								where education meets technology, and innovation becomes the
								driving force behind tangible success stories.`}
							</p>
						</div>
					</div>
				</Fade>
			</Container>
		</CollaborateWrapper>
	);
};

export default Collaborate;
